
import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import './events.css'
import img from "../../assets/images/AAM 840_300 (1).png";
import clock from "../../assets/images/clock.png"
import calendar from "../../assets/images/calendar.png"
import AllEventCard from './AllEventCard';
import AllEventSlider from './AllEventSlider/AllEventSlider';
import BreadCrumb from '../../main/components/BreadCrumb';

const Events = () => {
    const [eventDoc, setEvenDoc] = useState(null);
    const [pastEvents, setPastEvents] = useState(null);
    const [allEventInfo, setAllEvent] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.allEvents,
            })
            .then((response) => {
                const eventDoc = response.data.allEventss.edges[0].node;
                const allEventsDoc = response.data.allNew_events.edges;
                setAllEvent(allEventsDoc);
                setEvenDoc(eventDoc);

            })
            .catch((error) => {
                console.error(error);
            });
        window.scrollTo(0, 0);

    });

    useEffect(() => {

        const allPastEvens = allEventInfo?.filter(event => event.node.ispastevent === true)
        setPastEvents(allPastEvens)

    }, [allEventInfo])
    return (
        <section style={{ backgroundImage: 'url(' + eventDoc?.section_bg?.url + ')' }} className="pattern chart-container">
            <div className="container">
                <BreadCrumb nested={"Events "} />
                <h3 className="subtitle ">{eventDoc?.title}</h3>
                <div className="event-header">
                    <div className="card mb-3" >
                        <div className="row g-0">
                            <div className="col-md-8 top-banner-img">
                                <img src={eventDoc?.topbanner?.url} className=" " alt="..."></img>
                            </div>
                            <div className="col-md-4 event-reg-container d-flex flex-column  justify-content-evenly">

                                {eventDoc?.mode && <h3 className="offline-box">{eventDoc?.mode}</h3>}
                                <h5 className=" py-1 techno-title " >{eventDoc?.title}</h5>
                                <p className="reg-description">{eventDoc?.subtitle}</p>
                                <div className="d-flex ">
                                    <div className="d-flex me-5 align-items-center">

                                      {eventDoc?.date &&  <img src={calendar} className="img-fluid" alt="" />}
                                        <small className="secondary-text time-text  ps-2">{eventDoc?.date}</small>

                                    </div>
                                    <div className="d-flex align-items-center">

                                    {eventDoc?.time &&  <img src={clock} className="img-fluid" alt="" />}
                                        <small className="secondary-text time-text ps-2">{eventDoc?.time}</small>

                                    </div>
                                </div>
                                <div className="d-flex mt-3   mb-2 mb-md-0  justify-content-between align-items-center">
                                    <a className="text-decoration-none" href={`/event/${eventDoc?.view_details_id}`}> <button className="primary-outline-btn   px-4">{eventDoc?.view_btn_text}</button></a>
                                    <a target="_blank" href={eventDoc?.reg_link}> <button className="primary-btn px-4">{eventDoc?.reg_btn_text}</button></a>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <div >


                    <div className="nav  pb-4 nav-tabs" id="nav-tab" role="tablist">
                        <button
                            className="nav-link border-0 active primary-text"
                            id="call-paricipate-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#call-paricipate"
                            type="button"
                            role="tab"
                            aria-controls="call-paricipate"
                            aria-selected="true"
                        >
                            All Events
                        </button>
                        <button
                            className="nav-link border-0 primary-text "
                            id="problem-des-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#problem-des"
                            type="button"
                            role="tab"
                            aria-controls="problem-des"
                            aria-selected="false"
                        >
                            Past Events
                        </button>
                    </div>

                    <div className="tab-content pt-2" id="nav-tabContent">
                        <div
                            className="tab-pane fade show active "
                            id="call-paricipate"
                            role="tabpanel"
                            aria-labelledby="call-paricipate-tab"
                        >
                            {allEventInfo && <AllEventSlider allEventInfo={allEventInfo} />}
                        </div>
                        <div
                            className="tab-pane fade"
                            id="problem-des"
                            role="tabpanel"
                            aria-labelledby="problem-des-tab"
                        >
                            {allEventInfo && <AllEventSlider pastEvent={true} allEventInfo={pastEvents} />}

                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default Events;